import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging'
import { initializeApp } from 'firebase/app'
import { createNotification } from './notification'

const PUBLIC_KEY = 'BMobepK8i48TxCpZiefGjmpVJ91ugEADfz0bjPI_KhRtEglIBZ_OfkHFaahBL4yK5XCjI7bxbN4opEE_7adRMLQ'

const firebaseConfig = {
  apiKey: 'AIzaSyDHF3B8ynFGGHwsDZNZuaOn4xiVGuytz9k',
  authDomain: 'securitas-gea.firebaseapp.com',
  projectId: 'securitas-gea',
  storageBucket: 'securitas-gea.appspot.com',
  messagingSenderId: '907188761597',
  appId: '1:907188761597:web:e33b3081b745fc26261f94'
}

const app = initializeApp(firebaseConfig)

export const messaging = getMessaging(app)

function foregroundMessage (): void {
  onMessage(messaging, (payload) => {
    const { notification } = payload
    const { title, body } = notification
    createNotification({ title, body })
  })
}

async function retrieveToken (): Promise<string | null> {

  const supported = await isSupported()

  if (!supported) {
    console.warn('Firebase is not supported')
    return null
  }

  if (!messaging) return null

  const reg = await navigator.serviceWorker.getRegistration()

  const grantedNotifications = 'Notification' in window && Notification.permission !== 'granted'
    ? await Notification.requestPermission()
    : Notification.permission

  if (grantedNotifications !== 'granted') return null

  const token = await getToken(messaging, {
    vapidKey: PUBLIC_KEY,
    serviceWorkerRegistration: reg
  })

  return token
}

const firebase = {
  foregroundMessage,
  retrieveToken
}

export default firebase
